export interface IFileInfo {
  previousFileId: number;
  nextFileId: number;
  dateOfTaking: string;
  pep: number;
  lvet: number;
  ivct: number;
  pepAvg: number;
  lvetAvg: number;
  ivctAvg: number;
  /** File pipeline version; audio is available only for `"V2"`. */
  version?: string;
}
